import { BadgeCell } from '~/components/common';

import styles from './ManagerNameCellRenderer.module.scss';

const REPRESENTATIVE_BADGE_COLOR_MAP = { representative: { label: '대표' } };

/** 담당자 이름 셀. 첫 행은 대표 담당자라 '대표' 뱃지를 붙인다. */
const ManagerNameCellRenderer = ({ value, rowIndex }: { value?: string; rowIndex: number }) => {
  const isMaster = rowIndex === 0;
  return (
    <div className={styles['manager-name-cell-wrapper']}>
      <span>{value}</span>
      {isMaster && (
        <BadgeCell value="representative" colorMap={REPRESENTATIVE_BADGE_COLOR_MAP} size="small" variant="stroke" />
      )}
    </div>
  );
};

export default ManagerNameCellRenderer;
